import { useEffect } from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import './styles.css'

interface ShuffleConfirmModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function ShuffleConfirmModal({ isOpen, onConfirm, onCancel }: ShuffleConfirmModalProps) {
  const { t } = useLanguage()

  // Handle keyboard shortcuts when modal is open
  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === ' ') {
        event.preventDefault()
        onConfirm()
      } else if (event.key === 'Escape') {
        event.preventDefault()
        onCancel()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onConfirm, onCancel])

  if (!isOpen) return null

  return (
    <div className="shuffle-modal-overlay" onClick={onCancel}>
      <div className="shuffle-modal" onClick={(e) => e.stopPropagation()}>
        <div className="shuffle-modal-content">
          <p>{t.shuffleModal.message}</p>

          <div className="shuffle-modal-buttons">
            <button
              className="shuffle-modal-button confirm"
              onClick={onConfirm}
            >
              {t.shuffleModal.confirm} (Space)
            </button>
            <button
              className="shuffle-modal-button cancel"
              onClick={onCancel}
            >
              {t.shuffleModal.cancel} (Esc)
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}